import { Controller } from "@hotwired/stimulus"
import { revealRow } from "../lib/interaction_pages"

// Opens another interaction row on the same timeline and scrolls to it.
//
// "Also that night" points at siblings of the row you are reading, not
// somewhere else, so navigating away would lose the reader's place for no
// reason. A sibling on a page that has not loaded yet is paged in first. This
// opens the target in situ using the same `collapse-open` class
// `expanding_controller` toggles, so a row opened this way behaves exactly
// like one opened by clicking its own title.
export default class extends Controller {
  async open(event: { params: { row?: string } }) {
    const rowId = event.params?.row
    if (!rowId) return

    const row = await revealRow(rowId)
    if (!row) return

    const panel = row.querySelector('[data-expanding-target="expandableContent"]')
    panel?.classList.add("collapse-open")

    row.scrollIntoView({ behavior: "smooth", block: "center" })
  }
}
